module.exports = __webpack_public_path__ + "static/seo-report-video-e293581c591de6d321ba3b560c6c9851.png";